/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';
import {
    Alert, EditableText, InputGroup, Menu, MenuItem, Popover, Tooltip, RadioGroup, Radio
} from '@blueprintjs/core';
import {
    faCog, faTrashAlt, faClone
} from '@fortawesome/free-solid-svg-icons';
/* eslint-disable import/no-unresolved */
import ReactResizeDetector from 'react-resize-detector';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {PortalOverflowOverlay} from '../../../lib/overlays';
import {BlueBorderButton, BlueButton, CustomButton} from '../../../lib/buttons';
import Hotkeys from 'react-hot-keys';


const FormHeader = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 15px;
    font-size: 24px;
    font-weight: bold;
    color: #16335B;
    position: relative;
`;

const SettingsDiv = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const GridDiv = styled.div`
    width: 100px;
    heigth: 100px;
    display: grid;
    grid-template-columns: auto auto auto;
`;

const GridItemDiv = styled.div`
    background-color: rgba(255, 255, 255, 0.8);
    margin: 2px 1px 2px 1px;
    font-size: 10px;
    text-align: center;
`;


class RobotTeleop extends React.Component {
    constructor(props) {
        super(props);

        this.type = props.type;
        this.updateItem = props.updateItem;
        this.deleteItem = props.deleteItem;
        this.cloneComponent = props.cloneComponent;

        this.state = {
            id: props.id,
            availableSources: props.availableSources,
            name: props.initialState.name || 'Value',
            source: props.initialState.source || 'Select source',
            varAPIKey: props.initialState.varAPIKey || '',
            varEntityType: props.initialState.varEntityType || '',

            pressedButton: '',
            selectedRobot: '',

            popoverOpen: false,
            deletePopupOpen: false,
            tempSource: 'Select source',
            tempAPIKey: '',
            tempEntityType: '',
            fontSize: 10
        };
        this.value = 50;

        this.sendUpdate = this.sendUpdate.bind(this);
        this.delete = this.delete.bind(this);
        this.changeName = this.changeName.bind(this);
        this.openPopup = this.openPopup.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.closeConfirmPopup = this.closeConfirmPopup.bind(this);
        this.openDelete = this.openDelete.bind(this);
        this.closeDelete = this.closeDelete.bind(this);
        this.resize = this.resize.bind(this);
        this.changeSource = this.changeSource.bind(this);
        this.changeAPIKey = this.changeAPIKey.bind(this);
        this.changeEntityType = this.changeEntityType.bind(this);
        this.clone = this.clone.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.renderJoystick = this.renderJoystick.bind(this);
        this.handleRadioChange = this.handleRadioChange.bind(this);

        this.exampleRobots = ["robot1", "robot2", "robot3", "robot4", "robot5"];
    }

    static getDerivedStateFromProps(props) {
        return {
            id: props.id,
            availableSources: props.availableSources,
            name: props.initialState.name || 'Value',
            source: props.initialState.source || 'Select source',
            varAPIKey: props.initialState.varAPIKey || '',
            varEntityType: props.initialState.varEntityType || ''
        };
    }

    componentDidUpdate() {
    }

    handleRadioChange(event) {
        this.setState({selectedRobot: event.target.defaultValue});
    }

    onKeyUp() {
        this.setState({
            pressedButton: ''
        });
    }

    onKeyDown(keyName) {
        this.setState({
            pressedButton: keyName
        });
    }

    sendUpdate(key, value) {
        const {id} = this.state;
        this.updateItem(id, key, value);
    }

    delete() {
        const {id} = this.state;
        this.setState({deletePopupOpen: false});
        this.deleteItem(id);
    }

    changeName(value) {
        this.sendUpdate('name', value);
    }

    openPopup() {
        const {source, varAPIKey, varEntityType} = this.state;
        this.setState({
            popoverOpen: true,
            tempSource: source,
            tempAPIKey: varAPIKey,
            tempEntityType: varEntityType
        });
    }

    closePopup() {
        this.setState({
            popoverOpen: false,
            tempSource: 'Select source',
            tempAPIKey: '',
            tempEntityType: ''
        });
    }

    closeConfirmPopup() {
        const {tempSource, tempAPIKey, tempEntityType} = this.state;
        this.sendUpdate('source', tempSource);
        this.sendUpdate('varAPIKey', tempAPIKey);
        this.sendUpdate('varEntityType', tempEntityType);
        this.setState({popoverOpen: false});
    }

    openDelete() {
        this.setState({deletePopupOpen: true});
    }

    closeDelete() {
        this.setState({deletePopupOpen: false});
    }

    resize(width, height) {
        this.setState({fontSize: Math.min(height, (width / (String(this.value).length)))});
    }

    changeSource(value) {
        this.setState({tempSource: value});
    }

    changeAPIKey(event) {
        event.stopPropagation();
        this.setState({tempAPIKey: event.target.value});
    }

    changeEntityType(event) {
        event.stopPropagation();
        this.setState({tempEntityType: event.target.value});
    }

    clone() {
        const {id} = this.state;
        this.closePopup();
        this.cloneComponent(id);
    }

    renderJoystick() {
        const {pressedButton} = this.state;

        const upBColor = (pressedButton === "up") ? "#ff7e33" : "#16335B";
        const downBColor = (pressedButton === "down") ? "#ff7e33" : "#16335B";
        const leftBColor = (pressedButton === "left") ? "#ff7e33" : "#16335B";
        const rightBColor = (pressedButton === "right") ? "#ff7e33" : "#16335B";

        const stopBColor = (pressedButton === "enter") ? "#ff7e33" : "#16335B";

        const lBColor = (pressedButton === "z") ? "#ff7e33" : "#16335B";
        const rBColor = (pressedButton === "x") ? "#ff7e33" : "#16335B";

        const joystick = (
            <div
                style={{
                    width: '50%', height: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'
                }}
            >            
                <GridDiv>
                    <GridItemDiv> </GridItemDiv>
                    <GridItemDiv>
                        <CustomButton type="button" width="10px" height="10px" icon="caret-up" background={upBColor} backgroundHover="#ff7e33" intent="None" />                                     
                    </GridItemDiv>
                    <GridItemDiv> </GridItemDiv>
                    <GridItemDiv>
                        <CustomButton type="button" width="10px" height="10px" icon="caret-left" background={leftBColor} backgroundHover="#ff7e33" intent="None" />
                    </GridItemDiv>
                    <GridItemDiv> 
                        <CustomButton type="button" width="8px" height="8px" icon="delete" background={stopBColor} color="white" backgroundHover="#ff7e33" intent="None" />
                    </GridItemDiv>
                    <GridItemDiv>
                        <CustomButton type="button" width="10px" height="10px" icon="caret-right" background={rightBColor} backgroundHover="#ff7e33" intent="None" /> 
                    </GridItemDiv>
                    <GridItemDiv> </GridItemDiv>
                    <GridItemDiv>
                        <CustomButton type="button" width="10px" height="10px" icon="caret-down" background={downBColor} backgroundHover="#ff7e33" intent="None" />
                    </GridItemDiv>
                    <GridItemDiv> </GridItemDiv>
                </GridDiv>
                <div
                    style={{
                        width: '50%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-evenly'
                    }}
                >
                    <CustomButton type="button" width="10px" height="45px" intent="None" background={lBColor}>
                        L
                    </CustomButton>
                    <CustomButton type="button" width="10px" height="45px" intent="None" background={rBColor}>
                        R
                    </CustomButton>
                </div>
            </div>
        );

        return joystick;
    }

    render() {
        const {id, availableSources, name, popoverOpen, deletePopupOpen, selectedRobot, fontSize, tempSource, tempAPIKey, tempEntityType} = this.state;


        return ([
            <div
                style={{
                    width: '100%', height: '100%', background: 'white', padding: '1%', display: 'flex', flexDirection: 'column', borderRadius: '10px', fontSize: '16px'
                }}
            >
                <div
                    style={{
                        width: '100%',
                        height: '25px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        background: '#16335B',
                        borderTopLeftRadius: '10px',
                        borderTopRightRadius: '10px',
                        position: 'relative',
                        fontSize: '13px'
                    }}
                >
                    <div onMouseDown={(e) => e.stopPropagation()}>
                        <EditableText className="name-edit" onChange={this.changeName} onMouseDown={(e) => e.stopPropagation()} placeholder="Component Name" value={name} />
                    </div>
                    <div
                        style={{
                            height: '100%',
                            position: 'absolute',
                            top: '0px',
                            right: '2%',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                        onMouseDown={(e) => e.stopPropagation()}
                    >
                        <div style={{paddingRight: '5px'}}>
                            <Tooltip content="Clone component" popoverClassName="item-info-tooltip">
                                <FontAwesomeIcon icon={faClone} style={{color: 'white', fontSize: '13px', cursor: 'pointer'}} onClick={this.clone} />
                            </Tooltip>
                        </div>
                        <FontAwesomeIcon icon={faCog} style={{color: 'white', cursor: 'pointer'}} onClick={this.openPopup} />
                    </div>
                    <div
                        style={{
                            height: '100%',
                            position: 'absolute',
                            top: '0px',
                            left: '2%',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                        onMouseDown={(e) => e.stopPropagation()}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} style={{color: '#DE162F', cursor: 'pointer'}} onClick={this.openDelete} />
                    </div>
                </div>
                <ReactResizeDetector onResize={this.resize}>
                    {() => (
                        <div
                            id={`valueDiv_${id}`}
                            style={{
                                width: '100%',
                                height: 'calc(100% - 35px)',
                                maxHeight: '100%',
                                marginTop: '10px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                color: '#16335B',
                                fontSize: `${fontSize}px`
                            }}
                        >
                           
                            <Hotkeys
                                keyName="up, down, left, right, enter, z, x"
                                onKeyDown={this.onKeyDown}
                                onKeyUp={this.onKeyUp}
                            />
                            
                            <div
                                style={{
                                    width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-evenly'
                                }}
                            >                              
                                <div
                                    style={{
                                        width: '50%', height: '100%', display: 'flex', overflowY: 'auto', direction: "rtl" 
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '100%', height: '100%', display: 'flex', direction: "ltr", fontSize: '20px', margin: '5px 0px 15px 10px'  
                                        }}
                                    >
                                        <RadioGroup
                                            inline
                                            name="group"
                                            onChange={this.handleRadioChange}
                                            selectedValue={selectedRobot}
                                        >
                                            {this.exampleRobots.map((r) => (
                                                <Radio label={r} value={r} />
                                            ))}
                                        </RadioGroup>
                                    </div>
                                </div>
                                {this.renderJoystick()}
                            </div>
                        </div>
                    )}
                </ReactResizeDetector>
            </div>,
            <PortalOverflowOverlay key="settings" id="settings" isOpen={popoverOpen} width="450px" height="auto" background="white" borderRadius="10px" padding="20px" marginLeft="auto" marginRight="auto" color="black">
                <FormHeader>
                    {`${name} Settings`}
                </FormHeader>
                <SettingsDiv>
                    <Popover popoverClassName="custom-popover">
                        <BlueBorderButton type="button" width="410px" rightIcon="caret-down">
                            {tempSource}
                        </BlueBorderButton>
                        <Menu>
                            {availableSources.map((s) => (
                                <MenuItem text={s} onClick={() => this.changeSource(s)} />
                            ))}
                        </Menu>
                    </Popover>
                    <div
                        style={{
                            width: '100%', height: '100%', marginTop: '10px', display: 'flex', alignItems: 'center'
                        }}
                    >
                        <InputGroup
                            leftIcon="key"
                            placeholder="API Key"
                            onChange={this.changeAPIKey}
                            value={tempAPIKey}
                            fill
                            large
                        />
                    </div>
                    <div
                        style={{
                            width: '100%', height: '100%', marginTop: '10px', display: 'flex', alignItems: 'center'
                        }}
                    >
                        <InputGroup
                            leftIcon="array"
                            placeholder="Entity Type"
                            onChange={this.changeEntityType}
                            value={tempEntityType}
                            fill
                            large
                        />
                    </div>
                    <div
                        style={{
                            width: '300px', display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', marginTop: '10px'
                        }}
                    >
                        <BlueBorderButton
                            id="cancel"
                            type="button"
                            onClick={this.closePopup}
                        >
                            Cancel
                        </BlueBorderButton>
                        <BlueButton
                            id="save"
                            type="button"
                            onClick={this.closeConfirmPopup}
                        >
                            Save
                        </BlueButton>
                    </div>
                </SettingsDiv>
            </PortalOverflowOverlay>,
            <Alert key="delete-alert" style={{background: 'white', color: 'black'}} usePortal cancelButtonText="Cancel" confirmButtonText="Delete" icon="trash" intent="danger" isOpen={deletePopupOpen} onCancel={this.closeDelete} onConfirm={this.delete}>
                <p>
                    Are you sure you want to delete the component
                    <b style={{marginLeft: '5px'}}>{name}</b>
                    ?
                </p>
            </Alert>
        ]);
    }
}

const createRobotTeleop = ({id, type, initialState, updateItem, deleteItem, cloneComponent, sources}) => (
    <RobotTeleop
        id={id}
        type={type}
        initialState={initialState}
        updateItem={updateItem}
        deleteItem={deleteItem}
        cloneComponent={cloneComponent}
        availableSources={sources}
    />
);

export default createRobotTeleop;
